/** Hauteur réservée pour la bannière promo (px), alignée avec Navigation sticky offset. */
export const PROMO_BANNER_OFFSET_PX = 40;
